
import homeLogos from "@/assets/homeLogos";

// Map imported home logos to the shape used by the UI: { img, altText }
export const partnerLogo = homeLogos.map((l) => ({ img: l.src, altText: l.alt }));
